import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-dialogClose",
  "use": "icon-dialogClose-usage",
  "viewBox": "0 0 22 22",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 22 22\" fill=\"none\" id=\"icon-dialogClose\">\n  <path d=\"M22 2.08045L2.25752 21.8229L0.239076 19.8045L19.9816 0.0620117L22 2.08045Z\" fill=\"#888888\" />\n  <path d=\"M2.01844 0.177448L21.7609 19.9199L19.7425 21.9384L0 2.19589L2.01844 0.177448Z\" fill=\"#888888\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol